(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$scope', '$timeout', 'Auth', 'vcRecaptchaService', '$window'];

    function RequestResetController ($scope, $timeout, Auth, vcRecaptchaService, $window) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.errorMultipleAccounts = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;
        
    	vm.captchaValidated = null;
    	vm.publicCaptchaKey = $window.G_CAPTCHA_PUB_KEY;
    	
    	$scope.checkStud = function(){
	   		var weight="", zoom="", color="", space="";
			var matrStudMatch=vm.resetAccount.email.match(/^.+\.(\d+)@studenti\.uniroma1\.it$/)
			if (matrStudMatch){
				weight="bold"; zoom="2.5"; color="rgb(92, 73, 39)"; space="nowrap";
				vm.resetAccount.email=matrStudMatch[1];
			} else if (vm.resetAccount.email.match(/^.+\.(\d+)@.*$/)){
				var dom= vm.resetAccount.email.substring(vm.resetAccount.email.indexOf("@"))
				if (dom=="@studenti.uniroma1.it".substring(0,dom.length)){
					weight="bold"; zoom=dom.length>12?"2":"1.5"; color="rgb(102, 81, 44)"; space="nowrap";
				}
			}
			jQuery("#studHighlight").css("fontWeight",weight).css("zoom",zoom).css("color",color).css("whiteSpace",space);
		};
        
        //vm.type = 2;

        $timeout(function (){angular.element('#email').focus();});
		
        function requestReset () {

            vm.error = null;
            vm.success = null;
            vm.captchaValidated = null;
            
        	if(vcRecaptchaService.getResponse() === ""){//Deve validare il ReCaptcha
        		vm.captchaValidated = false;
        	}  
        	else{
        		vm.captchaValidated = true;
            
		        var objRequest = {};
	        	objRequest.mail = vm.resetAccount.email;
		        objRequest['g-recaptcha-response'] = vcRecaptchaService.getResponse();
		
		        Auth.resetPasswordInit(objRequest).then(function () {
		            vm.success = 'OK';
		        }).catch(function (response) {
		            if (response.status === 400 && response.data === 'email address not registered') {
		                vm.error = 'no-account';
		            } 
		            else if (response.status === 400 && response.data === 'private mail not found') {
		                vm.error = 'no-email';
		            }
		            else if (response.status === 400 && response.data === 'no suitable account found') {
		                vm.error = 'no-suitable-account';
		            }
	                else if (response.status === 400 && response.data === 'Found more than one username') {
	                    vm.error = 'multiple-results';
	                }
//	                else if (response.status === 400 && response.data === 'Account inactive') {
//	                    vm.error = 'account-inactive';
//	                }
	                else if (response.status === 400) {
	                    vm.error = response.data;
	                }
		            else {
		                vm.error = 'ERROR';
		            }
		            
		            vcRecaptchaService.reload();
		        });
        	}
            
        }
    }
})();
